<template>
  <div class="message-box">
    <div class="message-box-left-visitor">
      <b-avatar
        class="profile-customer"
        :text="
          (message.participant &&
            message.participant.name &&
            message.participant.name.charAt(0)) ||
          'N'
        "
      />
    </div>
    <div class="message-box-right">
      <p
        style="
          margin-bottom: 0;
          font-weight: bold;
          font-size: 0.8em;
          position: absolute;
          white-space: nowrap;
        "
      >
        {{ (message.participant && message.participant.email) || "No Email" }}
      </p>

      <div class="content-message">
        <div v-html="message.message" />
        <hr v-if="message.messageRef.length > 1" />
        <div
          v-if="index < message.messageRef.length && message.messageRef.length > 1"
          v-for="(commentIndex, index) in mailToShow"
        >
          <div style="word-wrap: break-word">
            {{ message.messageRef[index].content }}
          </div>
          <hr />
        </div>
        <div v-if="message.messageRef.length > 1" class="btn-group">
          <div v-if="mailToShow < message.messageRef.length">
            <h4
              @click="mailToShow = message.messageRef.length"
              class="btn-link"
            >
              {{ $t("ticket.show_more") }}
            </h4>
          </div>
          <div
            v-if="
              mailToShow >= message.messageRef.length &&
              message.messageRef.length > 1
            "
          >
            <h4 @click="mailToShow = 1" class="btn-link">
              {{ $t("ticket.show_less") }}
            </h4>
          </div>
        </div>

        <template v-if="message.attachments.length > 0">
          <div style="display: flex; gap: 0.25em">
            <FeatherIcon icon="PaperclipIcon" style="margin-top: 0.25em" />
            <p style="font-weight: bold; margin-bottom: 0.5em">
              {{ $t("ticket.attachment") }}
            </p>
          </div>
          <div style="display: grid; gap: 1em">
            <div
              v-for="each in message.attachments"
              :key="each.id"
              style="display: flex; align-items: center; gap: 0.5em"
            >
              <p style="margin-bottom: 0">
                <a target="_blank" :href="each.url">{{ each.fileName }}</a>
              </p>
            </div>
          </div>
        </template>
      </div>
      <p style="margin-bottom: 0; white-space: nowrap; position: absolute">
        {{ message.createdAt | formatShortDate }}
      </p>
    </div>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue";

export default {
  components: {
    BAvatar,
  },
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      mailToShow: 1,
    };
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.message-box {
  display: flex;
  justify-content: flex-start;
  //margin: 2em 1em 1em;
  margin-bottom: 2em;
  .h-stack {
    display: flex;
    justify-content: space-between;
  }
  .message-box-left-visitor {
    //padding: 1rem;
    padding-right: 1em;
  }

  .message-box-right {
    position: relative;
    padding-top: 0;
  }

  .content-detail {
    text-align: end;
    margin-bottom: -0.7rem !important;
  }

  .content-message {
    margin-top: 2em;
    white-space: break-spaces;
    background: white;
    padding: 0.7rem 1rem;
    border-radius: 0.357rem;
    box-shadow: 0 4px 8px 0 rgb(47 47 47 / 12%);
    max-width: 650px;
    margin-bottom: 0.5rem;
  }
  .profile-customer {
    font-weight: 400;
    border: 2px solid white;
    box-shadow: 0 4px 8px 0 rgb(47 47 47 / 12%);
  }
}
.btn-group {
  .btn-link {
    display: inline-block;
    padding-right: 5px;
    font-size: smaller;
    cursor: pointer;
    color: #8d5185 !important;
  }
  .btn-link:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
}
</style>
